import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const { user } = useAuth();
  const currentRole = localStorage.getItem("role");
  //console.log("my userrrrrr====>>>>", user)
  if (!user) {
    return <Navigate to="/login" />;
  }

  if(currentRole === 'admin' && currentRole !== role){
    return <Navigate to="/" />; 
  }

  if(currentRole === 'user' && currentRole !== role){
    return <Navigate to="/" />; 
  }

  // if (role && user.role !== role) {
  //   return <Navigate to="/" />;
  // }

  return children;
};

export default ProtectedRoute;
